import React, { useState } from "react";
import styled from "styled-components";
import { Button } from 'antd';
import { Radio } from 'antd';
import "antd/dist/antd.css";
import { withRouter } from 'react-router-dom';

import { useStore } from 'react-context-hook';



const Label = styled.div`
    margin: 8px 0;
`;

const ControlWrapper = styled.div`
    position: fixed;
    height: 300px;
    width: 260px;
    right: 0;
    bottom: 0;
`;

const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 16px;
`;

const StyledButton = styled(Button)`
    margin: 2px;
`;

const ControlButtonsHidden = ({ socket, history }) => {
    let apiHost = 'http://127.0.0.1:8000';
    if (process.env.NODE_ENV === 'production') {
        apiHost = 'https://tichu-backend.herokuapp.com';
    }
    const [gameState, ] = useStore('game', {});
    const [, setSetup] = useStore('setup', {});
    const [predictedHandCards, setPredictedHandCards] = useStore('predictedHandCards', {});
    const { loading } = predictedHandCards;

    const { done, possibleCombos } = gameState;

    const [agentNum, setAgentNum] = useState(0);
    const [limit, setLimit] = useState(100);

    const onReset = () => {
        fetch(apiHost + '/reset')
            .then(res => res.json())
            .then(() => {
                setSetup(true);
            })
            .catch(console.log);
    };

    const onPlayerSwitch = (e) => {
        setAgentNum(e.target.value);
    }

    const onLimitSwitch = (e) => {
        setLimit(e.target.value);
    }

    const predictHidden = () => {
        setPredictedHandCards({
            cards: [[],[],[],[]],
            arg: 0.0,
            prob: 0.0,
            loading: true,
        })
        socket.emit('pred_handcards', {player: agentNum, limit: limit});
    };
    return (
        <ControlWrapper>
            <Label>Predict for Agent</Label>
            <Radio.Group onChange={onPlayerSwitch} defaultValue={0} buttonStyle="solid">
                <Radio.Button value={0}>0</Radio.Button>
                <Radio.Button value={1}>1</Radio.Button>
                <Radio.Button value={2}>2</Radio.Button>
                <Radio.Button value={3}>3</Radio.Button>
            </Radio.Group>
            <Label>Comb. Limit</Label>
            <Radio.Group onChange={onLimitSwitch} defaultValue={100} buttonStyle="solid">
                <Radio.Button value={10}>10</Radio.Button>
                <Radio.Button value={100}>100</Radio.Button>
                <Radio.Button value={1000}>1000</Radio.Button>
            </Radio.Group>
            <ButtonWrapper>
                <StyledButton type="primary" onClick={predictHidden} loading={loading}>Predict Handcards</StyledButton>
                <StyledButton type="primary" danger onClick={() => history.push('/')}>Close View</StyledButton>
            </ButtonWrapper>
        </ControlWrapper>
    );
};

export default withRouter(ControlButtonsHidden);